import { Container } from 'react-bootstrap';
import aboutProfileImage from '../../../img/about-profile.png'

function AboutContent() {
  return (
    <section className="about-content">
      <Container className="about-content-container">
        <div className="about-content-image-wrap">
          <div className="about-content-image-bg" aria-hidden="true" />
          <img
            src={aboutProfileImage}
            className="about-content-image"
            alt="Dr. Guilherme Pedrosa"
          />
        </div>
        <div className="about-content-text">
          <h1 className="about-content-name">Guilherme Rego da Cunha Pedrosa</h1>
          <p className="about-content-subtitle">CRM-RJ 52.118662-0, RQE 61445 e RQE 51732</p>

          <ul className="about-content-list">
            <li>
              <strong>Médico Concursado de Clínica Médica</strong> no Hospital Universitário Clementino Fraga Filho (<strong className="about-content-acronym">HUCFF-UFRJ</strong>) desde 2026.
            </li>
            <li>
              <strong>Médico Preceptor de Clínica Médica</strong> no Hospital Universitário Servidores do Estado (<strong className="about-content-acronym">HUSE-UNIRIO</strong>) desde 2026;
            </li>
            <li>
              <strong>Médico Preceptor do Plantão Geral</strong> no Hospital Universitário Pedro Ernersto (<strong className="about-content-acronym">HUPE-UERJ</strong>) de 2024 a 2026;
            </li>
            <li>
              <strong>Residência Médica em Geriatria</strong> pelo Hospital Universitário Clementino Fraga Filho e Centro Gerontológico de Aeronáutica Brigadeiro Eduardo Gomes (<strong className="about-content-acronym">HUCFF-UFRJ / CGABEG</strong>), 2026;
            </li>
            <li>
              <strong>Residência Médica Ano Opcional em Clínica Médica</strong> pelo Hospital Universitário Pedro Ernersto (<strong className="about-content-acronym">HUPE-UERJ</strong>), 2024;
            </li>
            <li>
              <strong>Residência Médica em Clínica Médica</strong> pelo Hospital Federal de Ipanema (<strong className="about-content-acronym">HFI</strong>), 2023;
            </li>
            <li>
              <strong>Graduação em Medicina</strong> pela Universidade Estácio de Sá (<strong className="about-content-acronym">UNESA</strong>), 2021;
            </li>
          </ul>

          <p className="about-content-section-title"><strong>Associado à:</strong></p>
          <ul className="about-content-list">
            <li>
              <strong>Sociedade Brasileira de Geriatria e Gerontologia (<span className="about-content-acronym">SBGG</span>)</strong>.
            </li>
          </ul>

          {/* <p className="about-content-footer">
            Acesse: <a href="http://lattes.cnpq.br/" target="_blank" rel="noopener noreferrer" className="about-content-link">Currículo Lattes</a>
          </p> */}
        </div>
      </Container>
    </section>
  );
}

export default AboutContent;
